@if (hasIcon(brand)) {
  <div class="brand-logo-container">
    @switch (brand) {
      @case (cardBrand.Amex) {
        <gb-amex-icon [darkTheme]="darkTheme"></gb-amex-icon>
      }
      @case (cardBrand.Visa) {
        <gb-visa-icon [darkTheme]="darkTheme"></gb-visa-icon>
      }
      @case (cardBrand.Mastercard) {
        <gb-mastercard-icon [darkTheme]="darkTheme"></gb-mastercard-icon>
      }
      @case (cardBrand.GooglePay) {
        <gb-google-pay-icon></gb-google-pay-icon>
      }
      @case (cardBrand.ApplePay) {
        <gb-apple-pay-icon></gb-apple-pay-icon>
      }
    }
  </div>
} @else {
  <strong>{{ brand }}</strong>
}
